import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TweenLite} from "gsap";
import {Container, Sprite,Graphics} from "pixi.js";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
/**
 * Class description
 *
 * Created: 2020-05-15
 * @author shikha
 */

export class freezeLayers{
    private static _freezeTexture: PIXI.RenderTexture;
    private static _freezeSprite: Sprite;
    private static _blurSprite: Sprite;
    private static _blurTexture: PIXI.RenderTexture;
    private static _blurFilter: PIXI.filters.BlurFilter;
    private static _app: any;
    private static _layer:any;
    private static _stageMangerr:any;

    public static addBlur(dialogLayer:ScalableLayer,duration:number=0.2) {
        this.freezeInit();
        this._layer =  StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.BACKGROUND.name);
        //let duration = 0.2;
        this.renderTextures();
        this.resize();
        this._freezeSprite.alpha = 0;
        this._stageMangerr.addChildAt(this._freezeSprite, StageManager.stage.getChildIndex(dialogLayer));
        return new TweenLite(this._freezeSprite, duration, {
            alpha: 0.8,
            onComplete: ()=>{
                this.hideAllLayersBelow(dialogLayer)
                //this._stageMangerr.removeChild(this._layer);
            }
        });
    }
    public static onResize(dialogLayer:ScalableLayer){
        if(!this._stageMangerr){
            return
        }
        this.showAllLayersBelow(dialogLayer);
        this._freezeSprite.alpha=0;
        this._stageMangerr.removeChild(this._freezeSprite);
    }
    public static removeBlur(dialogLayer:ScalableLayer) {
        if(!this._stageMangerr){
            return
        }
        this.showAllLayersBelow(dialogLayer);
        let duration =0.001;
        return new TweenLite(this._freezeSprite, duration, {
            alpha: 0,
            onComplete: ()=>{
                this._stageMangerr.removeChild(this._freezeSprite);
            }
        });
    };
    public static renderTextures() {
        this._freezeTexture.resize(this._app.renderer.screen.width, this._app.renderer.screen.height);
        //The 100 extra pixels is there to compensate for non functioning edge clamp on the blur filter (bottom right corner is not clamped).
        this._blurTexture.resize(this._app.renderer.screen.width + 100, this._app.renderer.screen.height + 100);
        //Make sure game stage is rendered correctly before rendering to texture
        NolimitApplication.pixiApp.renderer.render(StageManager.stage, this._blurTexture, true, this.getStageMatrix());
        //Make sure that blur sprite is rendered with the blur.
        this._blurSprite.filterArea = new PIXI.Rectangle(0, 0, this._app.renderer.screen.width + 100, this._app.renderer.screen.height + 100);
        this._blurSprite.render(NolimitApplication.pixiApp.renderer);
        //Render blur sprite to final texture
        NolimitApplication.pixiApp.renderer.render(this._blurSprite, this._freezeTexture);
    };

    private static getStageMatrix() {
        var matrix = new PIXI.Matrix();
        matrix.translate(-NolimitApplication.screenBounds.left, -NolimitApplication.screenBounds.top);
        matrix.scale(NolimitApplication.pixiApp.stage.scale.x, NolimitApplication.pixiApp.stage.scale.y);
        return matrix;
    };
    private static hideAllLayersBelow(dialogLayer:ScalableLayer){
        let levelIndex =  StageManager.stage.getChildIndex(dialogLayer);
        StageManager.stage.children.forEach((layer,index)=>{
            if(levelIndex-1>index)
            layer.visible = false;
        })
    }
    private static showAllLayersBelow(dialogLayer:ScalableLayer){
        let levelIndex =  StageManager.stage.getChildIndex(dialogLayer);
        StageManager.stage.children.forEach((layer,index)=>{
            if(levelIndex-1>index)
                layer.visible = true;
        })
    }

    public static resize() {
        this._freezeSprite.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        this._freezeSprite.width = NolimitApplication.screenBounds.width;
        this._freezeSprite.height = NolimitApplication.screenBounds.height;
    };
    private static freezeInit() {
        this._stageMangerr = StageManager.stage;
        this._app = StageManager;
        this._freezeTexture = PIXI.RenderTexture.create({
            width: this._app.renderer.screen.width,
            height: this._app.renderer.screen.height,
            resolution: 0.1,
            scaleMode: PIXI.SCALE_MODES.LINEAR
        });
        this._freezeSprite = new PIXI.Sprite(this._freezeTexture);
        this._freezeSprite.name = "freezeSprite";
        this._blurTexture = PIXI.RenderTexture.create({
            width: this._app.renderer.screen.width,
            height: this._app.renderer.screen.height,
            resolution: 0.1,
            scaleMode: PIXI.SCALE_MODES.LINEAR
        });
        this._blurSprite = new PIXI.Sprite(this._blurTexture);
        this._blurFilter = new PIXI.filters.BlurFilter();
        this._blurFilter.autoFit = false;
        this._blurFilter.repeatEdgePixels = true;
        this._blurFilter.blurX = 4;
        this._blurFilter.blurY = 4;
        this._blurSprite.filters = [this._blurFilter];
    }

}